import theme from './theme';

const { palette } = theme;

export const themeCSSVariables = {
  '--color-primary': palette.primary[0],
  '--color-primary-dark': palette.primary[1],
  '--color-primary-light': palette.primary[4],
  '--color-primary-3': palette.primary[3],
  '--color-secondary': palette.secondary[0],
  '--color-secondary-light': palette.secondary[1],
  '--color-text': palette.text[0],
  '--color-text-light': palette.text[1],
  '--color-text-secondary': palette.text[2],
  '--color-border': palette.border[0],
  '--color-border-light': '#f0f0f0',
  '--color-bg': palette.secondary[1],
  '--color-success': palette.success[0],
  '--color-warning': palette.warning[0],
  '--color-error': palette.error[0],
  '--color-sidebar-bg': palette.secondary[0],
  '--color-sidebar-bg-dark': palette.secondary[4],
  '--radius-sm': '4px',
  '--radius-md': '6px',
  '--radius-lg': '8px',
  '--radius-xl': '12px',
  '--shadow-sm': '0 1px 3px rgba(0, 0, 0, 0.08)',
  '--shadow-md': '0 2px 8px rgba(0, 0, 0, 0.12)',
  '--shadow-lg': '0 6px 20px rgba(15, 23, 42, 0.12)',
  '--font-family': "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
};

export function generateThemeCSSBlock() {
  return Object.entries(themeCSSVariables)
    .map(([key, value]) => `  ${key}: ${value};`)
    .join('\n');
}
